import { UseQueryOptions, useQuery } from 'react-query';

import { minutesToMilliseconds } from 'date-fns';

import { fetchMyPlayerStats, fetchPlayer } from '@api/chatbot';
import { QUERY_KEYS } from '@constants';
import { IPlayer } from '@model';

export const usePlayer = (
  id: number | undefined,
  options?: UseQueryOptions<IPlayer>
) => {
  const query = useQuery<IPlayer>(
    QUERY_KEYS.PLAYER(id),
    () => fetchPlayer(id),
    {
      enabled: !!id,
      staleTime: minutesToMilliseconds(60),
      cacheTime: minutesToMilliseconds(60),
      ...options,
    }
  );

  return query;
};

export const usePlayerStats = (options?: UseQueryOptions<IPlayer>) => {
  const query = useQuery<IPlayer>(
    QUERY_KEYS.MY_STATS,
    () => fetchMyPlayerStats(),
    {
      staleTime: minutesToMilliseconds(60),
      cacheTime: minutesToMilliseconds(60),
      ...options,
    }
  );

  return query;
};
